export const OkrVI = {
    "okrAdd": "Tạo mới mục tiêu OKR",
    "dashboardOkr":"Dashboard",
    "managementOkr":"Quản lý OKRs",
    "personnelOkr": "OKRs cá nhân",
    "departmentOkr": "OKRs phòng ban"
}